export default {
  test: "test",
  common: {
    message: {
      created: "作成しました",
      updated: "更新しました",
      deleted: "削除しました",
      no_result: "該当データは見つかりませんでした",
      no_more: "データはもうありません",
      errors: {
        image: "5MB以内のjpg・jpeg・png 画像をアップロードしてください",
      },
    },
    modal: {
      cancel_content:
        "変更内容を破棄して編集を終了します。この操作は取り消せません。",
      reset_profile: "変更内容を破棄して、パスワード変更画面を開きます。",
    },
    buttons: {
      cancel: "キャンセル",
      yes: "はい",
      no: "いいえ",
    },
  },
  post_group: {
    have_used_cannot_delete: "This post group have used, so it cannot delete",
    confirm_delete: "{name}を削除します。",
    confirm_cancel:
      "Do you reset post group just additional after close this modal",
  },
};
